import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the top of the page when moving between public pages
 * (e.g. Home -> Advertising), instead of keeping the previous scroll position.
 *
 * Not applied to:
 * - CRM pages (/app/*), where staying in place is expected
 * - the ePublisher Knowledge Base, which manages its own scrolling
 */
const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/app') || pathname.startsWith('/epublisher-kb')) return;
    window.scrollTo(0, 0);
  }, [pathname]);
};

export default useScrollToTop;
